import { ICustomerDetail } from "@interfaces";
import { breakpoint } from "@utilities";
import _ from "lodash";
import styled, { keyframes } from "styled-components";

export interface Suggestion {
    first_name: string | null;
    last_name: string | null;
    phone_number: number;
    country_code: string;
    email: string;
    id: string;
}

interface TravelerSuggestionsBottomSheetProps {
    isOpen: boolean;
    onClose: () => void;
    suggestions: ICustomerDetail[];
    onRemove: (travelerId: number) => void;
    countriesData: any[];
}

export const TravellerRemoveBoxDesktopView = ({
    isOpen,
    suggestions,
    countriesData,
    onRemove,
    onClose
}: TravelerSuggestionsBottomSheetProps) => {
    if (!isOpen) return null;

    const getCountryName = (targetCode: string | undefined) =>
        _.get(_.find(countriesData, { countryCode: targetCode }), "name", "Not Found");

    return (
        <TravellerPopup onClick={onClose}>
            <Popup onClick={(e) => e.stopPropagation()}>
                <div className="details-container">
                    <h2>Selected Travellers</h2>
                    {_.map(suggestions, (user) => (
                        <div className="details" key={user.id}>
                            <NameContainer>
                                <div>
                                    <h1>
                                        {user.first_name} {user.last_name}{" "}
                                        {user.is_primary === 1 && "(you)"}
                                    </h1>
                                    <p>
                                        {user.phone_number}, {getCountryName(user.country_code)},{" "}
                                        {user.email}
                                    </p>
                                </div>
                                <button type="button" onClick={() => onRemove(Number(user.id))}>
                                    <img src="/images/deleteSvgButton.svg" alt="delete" />
                                </button>
                            </NameContainer>
                        </div>
                    ))}
                </div>
            </Popup>
        </TravellerPopup>
    );
};

export const TravellerRemoveBox = ({
    isOpen,
    onClose,
    suggestions,
    countriesData,
    onRemove,
}: TravelerSuggestionsBottomSheetProps) => {
    if (!isOpen) return null;

    const getCountryName = (targetCode: string | undefined) =>
        _.get(_.find(countriesData, { countryCode: targetCode }), "name", "Not Found");

    return (
        <>
            <Overlay onClick={onClose} />
            <BottomSheet onClick={(e) => e.stopPropagation()}>
                <div className="details-container">
                    <h2>Selected Travellers</h2>
                    {_.map(suggestions, (user) => (
                        <div className="details" key={user.id}>
                            <NameContainer>
                                <div>
                                    <h1>
                                        {user.first_name} {user.last_name}{" "}
                                        {user.is_primary === 1 && "(you)"}
                                    </h1>
                                    <p>
                                        {user.phone_number}, {getCountryName(user.country_code)},{" "}
                                        {user.email}
                                    </p>
                                </div>
                                <button type="button" onClick={() => onRemove(Number(user.id))}>
                                    <img src="/images/deleteSvgButton.svg" alt="delete" />
                                </button>
                            </NameContainer>
                        </div>
                    ))}
                </div>
            </BottomSheet>
        </>
    );
};

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const Overlay = styled.div`
    display: none;
    ${[breakpoint.breakMobile, breakpoint.breakSmall].map(
        (breakpointFn) => breakpointFn`
    display: block;`,
    )}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 10;
    cursor: pointer;
`;

const BottomSheet = styled.div`
    display: none;
    ${[breakpoint.breakMobile, breakpoint.breakSmall].map(
        (breakpointFn) => breakpointFn`
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 15;
        background: #fff;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        animation: ${slideUp} 0.3s ease-out;
        padding: 38px 16px 0px 16px;
        .details-container{
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-bottom: 30px;
            h2 {
                font-size: 20px;
                font-weight: 600;
            }
            .details {
                display : flex;
                align-items : center;
                gap : 16px;
                div{
                    display : flex;
                    flex-direction : column;
                    gap : 6px;
                    h1{
                        font-size : 24px;
                        font-weight : 600;  
                    }
                    p{
                        font-size : 12px;
                        color : #6E7375;
                    }
                }
            }
            
        }
    `,
    )}
`;

const NameContainer = styled.div`
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    width: 100%;
`;

const TravellerPopup = styled.div`
    ${breakpoint.breakOnlyMobile`
        display: none;
    `}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 15;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Popup = styled.div`
    background: #fff;
    border-radius: 8px;
    padding: 38px 24px 0px 24px;
    width: 700px;
    .details-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 30px;
        h2 {
            font-size: 20px;
            font-weight: 600;
        }
        .details {
            display: flex;
            align-items: center;
            gap: 16px;
            div {
                display: flex;
                flex-direction: column;
                gap: 6px;
                h1 {
                    font-size: 24px;
                    font-weight: 600;
                }
                p {
                    font-size: 12px;
                    color: #6e7375;
                }
            }
        }
    }
`;
